import React from "react";
import { Outlet } from "react-router-dom";
import { Footer } from "components/Footer";
import { Header } from "components/Header";

export const MainLayout: React.FC = () => {
  return (
    <div className="app-container">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
